const discountTypesMap = {
  amount: 'amount',
  percentage: 'percentage',
}

export default discountTypesMap
